<template>
  <div id="DnsTalk">
    <div class="eg-slideshow">
      <img src="./assets/kermit.png" class="kermit">
      <slide>
        <h1>Spaß mit DNS</h1>
      </slide>

      <slide :steps="9">
        <h3>Domain</h3>
        <div v-if="step >= 2 && step <= 5">

          <div v-if="step >= 2" class="centered">
            <p>Vereinfachter Aufbau einer Internetadresse</p>
            <img src="./assets/url-structure.png" alt="">
          </div>

          <ol v-if="step >= 3">
            <li v-if="step >= 3">Protokoll</li>
            <li v-if="step >= 4">Domain</li>
            <li v-if="step >= 5">Pfad</li>
          </ol>
        </div>

        <ul v-if="step >= 6">
          <li v-if="step >= 7">eine <b>Domain</b> verweist auf eine <b>IP-Adresse</b></li>
          <li v-if="step >= 8">ein Rechner im Internet lässt sich anhand einer <b>IP-Adresse</b> eindeutig identifizieren</li>
          <li v-if="step >= 9">Nutzerfreundlichkeit durch <b>Domains</b></li>
        </ul>
      </slide>

      <slide :steps="5">
        <h3>DNS</h3>
        <ul>
          <li v-if="step >= 2"><b>D</b>omain <b>N</b>ame <b>S</b>ystem</li>
          <li v-if="step >= 3">Netzwerk aus <b>Nameservern</b></li>
          <li v-if="step >= 4"><b>Name-Server</b> übersetzen eine <b>Domain</b> in eine <b>IP-Adresse</b></li>
          <li v-if="step >= 5">auf einem <b>Name-Server</b> werden <b>DNS-Records</b> festgelegt</li>
        </ul>
      </slide>

      <slide :steps="6">
        <h3>DNS-Records</h3>
        <ul>
          <li v-if="step >= 2"><b>DNS-Records</b> sind Zuweisungen von einer <b>Domain</b> auf eine <b>IP-Adresse</b></li>
          <li v-if="step >= 3"><b>A-Record</b> &amp; <b>AAAA-Record</b> für Webseiten</li>
          <li v-if="step >= 4"><b>MX-Record</b> für E-Mail</li>
          <li v-if="step >= 5"><b>NS-Record</b> für den zuständigen <b>Name-Server</b></li>
          <li v-if="step >= 6">
            <a href="https://toolbox.googleapps.com/apps/dig/" target="_blank">Google DNS Tool</a>
          </li>
        </ul>
      </slide>

      <slide>
        <h3>Ablauf einer DNS-Anfrage</h3>
        <div class="centered">
          <img src="./assets/dns-resolve.png">
        </div>
      </slide>

      <slide :steps="3">
        <h3>Providerwechsel / Auth-Code</h3>
        <ul>
          <li v-if="step >= 2">bei einem <b>Providerwechsel</b> wird ein neuer Name-Server beim zuständigen Register hinterlegt</li>
          <li v-if="step >= 3">der <b>Auth-Code</b> ist ein Passwort, welches den neuen <b>Provider</b>, für den Wechsel, bevollmächtigt</li>
          <!-- <li v-if="step >= 4">meldet der zuständigen Verwaltungsstelle (bei <b>.de</b> Adressen die <b>DENIC</b>) den neuen <b>Name-Server</b></li> -->
        </ul>
      </slide>

      <slide :steps="6">
        <h3>Dauer eines Providerwechsels</h3>
        <ul>
          <li v-if="step >= 2">schwer zu beeinflussen</li>
          <li v-if="step >= 3">um kurze Antwortzeiten zu ermöglichen müssen die Einträge zwischengespeichert werden</li>
          <li v-if="step >= 4">TTL (Time to Live)</li>
          <li v-if="step >= 5">Änderungen müssen von einem Weltweiten Netzwerk erkannt und übernommen werden</li>
          <li v-if="step >= 6">abhängig vom Internetanbieter, Router, ...</li>
        </ul>
      </slide>

      <slide>
        <h1>Fragen?</h1>
      </slide>
    </div>
  </div>
</template>

<script>
import eagle from 'eagle.js'
export default {
  name: 'DnsTalk',
  mixins: [eagle.slideshow]
}
</script>

<style lang='scss'>
@import url(https://fonts.googleapis.com/css?family=Roboto:400,700,900);

#DnsTalk {
  b {
    font-weight: 900;
  }

  ul > li + li,
  ol > li + li {
    margin-top: 20px;
  }

  .eg-slideshow {
    font-family: "Roboto";
    color: #333;
    background-color: #fff;
    .eg-slide {
      .eg-slide-content {
        width: 25em;
        max-width: 80%;
        margin: 0 auto;
      }
    }
  }
  .eg-slide-content {
    width: 25em;
    max-width: 80%;
    margin: 0 auto;
  }

  .centered {
    text-align: center;
  }

  .kermit {
    position: absolute;
    transform-origin: center center;
    // animation: kermit 5s infinite linear;
    right: -2px;
    bottom: 0px;
  }

  // @keyframes kermit {
  //   0% {
  //     transform: translate(0, 0) rotate(360deg);
  //   }
  //   25% {
  //     transform: translate(0, calc(-100vh + 100%)) rotate(270deg);
  //   }
  //   50% {
  //     transform: translate(calc(-100vw + 100%), calc(-100vh + 100%)) rotate(180deg);
  //   }
  //   75% {
  //     transform: translate(calc(-100vw + 100%), 0) rotate(90deg);
  //   }
  //   100% {
  //     transform: translate(0, 0) rotate(0deg);
  //   }
  // }
}
</style>
